import React from "react";
import parse from "html-react-parser";
import PropTypes from "prop-types";
import {
  leftArrow,
  rightArrow,
} from "../../../assets/images/calculatorIcons";
import "./pagination.scss";
import { getPagesArray } from "./pagination.helpers";

const Pagination = ({
  pageNumber,
  totalPages,
  updatePageNumber,
}) => {
  if (totalPages < 1) {
    return null;
  }

  const handleUpdatePageNumber = pageNumber => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    updatePageNumber(pageNumber);
  };

  const handleRightClick = () => {
    if (pageNumber + 1 === totalPages) {
      return;
    }
    handleUpdatePageNumber(pageNumber + 1);
  };

  const handleLeftClick = () => {
    if (pageNumber === 0) return;
    handleUpdatePageNumber(pageNumber - 1);
  };

  return (
    <div className="page-number prevent-select">
      <div
        className={`page-item page-left ${
          pageNumber === 0 ? " disabled" : ""
        }`}
        onClick={handleLeftClick}
      >
        {parse(leftArrow)}
      </div>
      {getPagesArray(pageNumber + 1, totalPages)?.map(
        page => {
          return (
            <div
              key={page}
              className={
                "page-item page-number" +
                (page === pageNumber + 1 ? " selected" : "")
              }
              onClick={() => {
                handleUpdatePageNumber(page - 1);
              }}
            >
              {page}
            </div>
          );
        }
      )}
      <div
        className={
          "page-item page-right" +
          (pageNumber + 1 === totalPages ? " disabled" : "")
        }
        onClick={handleRightClick}
      >
        {parse(rightArrow)}
      </div>
    </div>
  );
};

Pagination.propTypes = {
  pageNumber: PropTypes.number,
  totalPages: PropTypes.number,
  updatePageNumber: PropTypes.func,
};

export default Pagination;
